export const CLIENT_PROFILE_ENTRY_MESSAGES = {
  NOT_FOUND: 'No client profile records were found',
  DEFAULT: 'Client profile records were found',
};


// WEBPACK FOOTER //
// ./src/features/client-profile/constants/clientProfileEntryMessages.js